import { render, staticRenderFns } from "./FodderProduction.vue?vue&type=template&id=2303f538&scoped=true&"
import script from "./FodderProduction.vue?vue&type=script&lang=js&"
export * from "./FodderProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2303f538",
  null
  
)

export default component.exports